import {
    convertIsoToPersian,
    options,
    yearOptions, timeOptions, parseGlucoseCount
} from 'utils/functions-utils';

export function dataStructureGridTable(data, filterChoice) {
    let gridData = [];
    let array05 = [[], [], [], [], [], [], []];
    let array59 = [[], [], [], [], [], [], []];
    let array911 = [[], [], [], [], [], [], []];
    let array1114 = [[], [], [], [], [], [], []];
    let array1417 = [[], [], [], [], [], [], []];
    let array1722 = [[], [], [], [], [], [], []];
    let array2224 = [[], [], [], [], [], [], []];
    let filterData = data?.gridData;
    if (parseInt(filterChoice) !== 3) {
        filterData = data?.gridData.filter((item) => {
            return item?.glucoseStatus === filterChoice;
        });
    }
    filterData?.reverse().map((item) => {
        let Time = item.estimatedDate.match(/\d\d:\d\d/);
        let hour = parseInt(Time[0].slice(0, 2));
        if (hour >= 0 && hour < 5) {
            array05[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 5 && hour < 9) {
            array59[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 9 && hour < 11) {
            array911[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 11 && hour < 14) {
            array1114[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 14 && hour < 17) {
            array1417[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 17 && hour < 22) {
            array1722[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        } else if (hour >= 22 && hour < 24) {
            array2224[item.dayOfWeek].push([item.testResult.toString(), item.glucoseStatus]);
        }
    });
    let days = [
        'جمعه',
        'پنجشنبه',
        'چهارشنبه',
        'سه‌شنبه',
        'دوشنبه',
        'یکشنبه',
        'شنبه'
    ];
    for (let i = 6; i >= 0; i--) {
        gridData.push([
            ...[
                days[i],
                array05[i], array59[i], array911[i],
                array1114[i], array1417[i], array1722[i], array2224[i]
            ]
        ]);
    }
    const {dateFrom, dateTo} = calculateFromTo(data.from, data.to);
    return {data: gridData, from: dateFrom, to: dateTo};
}

const calculateFromTo = (from, to) => {
    //api return last week a day more so we minus that
    let friday = new Date(to);
    friday.setDate(friday.getDate() - 1);
    const dateTo = convertIsoToPersian(friday);
    const dateFrom = convertIsoToPersian(from);
    console.log(dateTo, dateFrom);
    return {dateFrom, dateTo};
};

export function dataFilterListTable(data, filterChoice) {
    let finalObj = Object.assign({}, data);

    let filteredData = finalObj?.pages.map((page) => {
        let filterData = page;
        // filter data by (high inRange low) filter
        if (parseInt(filterChoice) !== 3) {
            filterData = page.filter((item) => {
                return item?.glucoseStatus === filterChoice;
            });
        }
        return filterData;
    });
    Object.keys(finalObj).map((key) =>
        key === 'pages' ? (finalObj[key] = filteredData) : ''
    );
    return finalObj;
}

export const destructureDataForModalCards = (cardData) => {
    const id = cardData?.id;
    let weekday, dateNumeric, time;
    if (cardData?.dateNumeric) {
        weekday = cardData?.dateNumeric?.fullDateLong;
        dateNumeric = cardData?.dateNumeric?.numericDate;
        time = cardData?.time;
    } else {
        const timestamp = new Date(cardData?.estimatedDate);
        // year date 1400/1/1
        dateNumeric = new Intl.DateTimeFormat('fa-IR', yearOptions).format(
            timestamp
        );
        // hour
        time = new Intl.DateTimeFormat('en-IR', timeOptions).format(timestamp);
        // weekday   => دوشنبه 5 مهر
        weekday = new Intl.DateTimeFormat('fa-IR', options).format(timestamp);
    }

    // suger result
    const testResult = parseGlucoseCount(cardData?.testResult);
    // mealStatus => postmeal/premeal/unknown
    const mealStatus = cardData?.mealStatus;
    // glocouse status => high/ inRange / Low
    const glucoseStatus = cardData?.glucoseStatus;
    const jalaliDate = cardData?.jalaliDate;

    return {
        id,
        testResult,
        glucoseStatus,
        time,
        mealStatus,
        jalaliDate,
        dateNumeric,
        weekday
    };
};
